export const ERROR_CONTACT_INFO_INCOMPLETE =
    'Contact information incomplete. Try again.';
export const ERROR_APPLE_PAY_CONFIG =
    'Something went wrong with Apple Pay. Please try again or pay another way.';
export const ERROR_EXPRESS_CHECKOUT_ORDER =
    'Something went wrong. Check your card and try again or pay another way.';
